// src/i18n.js
// String tables ported from the WP plugin's gettext catalog
// (../visamundi-widget/languages/travel-visa-widget-fr_FR.po).
// Placeholders use %s (string) / %d (integer) like the original printf format.
// Two strings missing from the FR .po use proposed translations (see spec annex).

export const STRINGS = {
  en: {
    titleTemplate: 'Find your %s <span class="vm__nw">with %s</span>', // %s = highlighted phrase, %s = logo
    visaWord: 'travel document',
    nationality: 'Nationality',
    destination: 'Destination',
    choose: 'Select a country',
    nationalityQuestion: 'What is your nationality ?',
    destinationQuestion: 'What is your destination ?',
    stRequired: 'Visa required',
    stArrival: 'Visa on arrival',
    stEvisa: 'Travel document',
    stHayya: 'Hayya permit',
    stFree: 'Visa-free',
    stNoAdmission: 'No admission',
    stUnknown: 'To be confirmed',
    stHome: 'No document needed',
    sentence: 'To travel %s %s with a %s passport, %s.', // prefix, name, demonym, requirement
    reqVisaRequired: 'a visa is required',
    reqVisaOnArrival: 'a visa is granted on arrival',
    reqEvisa: 'you will need a travel document',
    reqHayya: 'you will need a Hayya Entry Permit',
    reqVisaFree: 'no visa is required',
    reqNoAdmission: "it's compromised because no admission is possible",
    reqUnknown: "we don't have information on what is needed",
    stayDays: 'no visa is required for a stay of up to %d days',
    reqHome: 'no travel document is required',
    getVisa: 'Get my Visa',
    getOtherDocument: 'Get my other mandatory document',
    getDocument: 'Get my Document',
    discoverDestination: 'Discover this destination',
    notified: 'Our teams have been notified and will update the data accordingly.',
    loading: 'Checking requirements…',
    error: 'An error occurred',
  },
  fr: {
    titleTemplate: 'Trouvez votre %s <span class="vm__nw">avec %s</span>',
    visaWord: 'document de voyage',
    nationality: 'Nationalité',
    destination: 'Destination',
    choose: 'Choisir un pays',
    nationalityQuestion: 'Quelle est votre nationalité ?',
    destinationQuestion: 'Quelle est votre destination ?',
    stRequired: 'Visa requis',
    stArrival: 'Visa à l’arrivée',
    stEvisa: 'Document de voyage',
    stHayya: 'Permis Hayya',
    stFree: 'Sans visa',
    stNoAdmission: 'Aucune admission',
    stUnknown: 'À confirmer',
    stHome: 'Aucun document requis',
    sentence: 'Pour voyager %s %s avec un passeport %s, %s.',
    reqVisaRequired: 'un visa est requis',
    reqVisaOnArrival: 'un visa est accordé à l’arrivée',
    reqEvisa: 'vous aurez besoin d’un document de voyage',
    reqHayya: 'vous aurez besoin d’un permis d’entrée Hayya',
    reqVisaFree: 'aucun visa n’est requis',
    reqNoAdmission: 'c’est compromis car aucune admission n’est possible',
    reqUnknown: 'nous n’avons pas d’informations sur ce qui est nécessaire',
    stayDays: 'aucun visa n’est requis pour un séjour jusqu’à %d jours',
    reqHome: 'aucun document de voyage n’est requis',
    getVisa: 'Obtenir mon Visa',
    getOtherDocument: 'Obtenir mon autre document obligatoire',
    getDocument: 'Obtenir mon document',
    discoverDestination: 'Découvrir cette destination',
    notified: 'Nos équipes ont été notifiées et mettront les données à jour en conséquence.',
    loading: 'Vérification des conditions…',
    error: 'Une erreur s’est produite',
  },
};

const DEFAULT_LANG = 'en';

export function detectLanguage(raw) {
  if (!raw || typeof raw !== 'string') return DEFAULT_LANG;
  const base = raw.trim().slice(0, 2).toLowerCase();
  return STRINGS[base] ? base : DEFAULT_LANG;
}

export function t(lang, key, ...args) {
  const table = STRINGS[lang] || STRINGS[DEFAULT_LANG];
  let str = table[key] ?? STRINGS[DEFAULT_LANG][key] ?? key;
  let i = 0;
  str = str.replace(/%[sd]/g, () => (i < args.length ? String(args[i++]) : ''));
  return str;
}
